import { Component } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ClientService } from '../services/client.service';
import { RouterModule } from '@angular/router';
import { APIUrl } from '../constant/api-call';
import { PERMISSION } from '../constant/permission';
import { PrimeNgModule } from '../shared/prime-ng.module';
import { CommonModule } from '@angular/common';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { ProjectService } from '../services/project.service';

@Component({
  selector: 'app-project-list',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, PrimeNgModule, RouterModule, ToggleButtonModule],
  templateUrl: './project-list.component.html',
  styleUrls: ['./project-list.component.css']
})
export class ProjectListComponent {
  public projectForm: FormGroup;
  public commonDataObject = {
    APIObj: APIUrl,
    permissionObj: PERMISSION,
    selectedProject: null,
    issuccessAlert: false,
    iserrorAlert: false,
    apiMeassge: '',
    displayDialog: false,
    deleteDialog: false
  }
  public defaultColDef: ColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    flex: 1
  };
  public columnDefs: ColDef[] = [
    {
      headerName: 'Sr. No.',
      flex: 0.5,
      valueGetter: (params: any) => params.node?.rowIndex ? params.node.rowIndex + 1  + '.' : 1,
    },
    {
      headerName: 'Project Name',
      field: 'project_name',
      flex: 2,
      sortable: true,
      filter: true,
    },
    {
      headerName: 'Description',
      field: 'project_description',
      flex: 3,
    },
    {
      headerName: 'Co-ordinator',
      field: 'project_coordinator',
      flex: 1.5,
      filter: true
    },
    {
      headerName: 'Co-Coordinator',
      field: 'project_co_coordinator',
      flex: 1.5,
      filter: true
    },
    {
      headerName: 'Status',
      field: 'is_active',
      flex: 1,
      sortable: true,
      filter: true,
      valueFormatter: (params: any) => {
        return params.value ? 'Active' : 'In Active';
      }
    },
    {
      headerName: 'Actions',
      flex: 1,
      cellRenderer: () => `
      <span>
        <i class="fa fa-edit text-primary me-2 edit-btn" title="Edit"></i>
        <i class="fa fa-trash text-danger delete-btn" title="Delete"></i>
      </span>`,
      onCellClicked: (params: any) => {
        const target = params?.event?.target as HTMLElement;
        if (target.classList.contains('edit-btn')) {
          this.editProject(params.data);
        }
        if (target.classList.contains('delete-btn')) {
          this.commonDataObject.deleteDialog = true;
          this.commonDataObject.selectedProject = params.data;
        }
      }
    }
  ];
  public gridApi: any;

  constructor(
    private fb: FormBuilder,
    private clientService: ClientService,
    public projectService: ProjectService
  ) {
    this.projectForm = this.fb.group({
      project_id: [''],
      project_name: ['', Validators.required],
      project_description: ['', Validators.required],
      project_coordinator: ['', Validators.required],
      project_co_coordinator: ['', Validators.required],
      is_active: [true]
    });
  }

  ngOnInit() {
    this.projectService.getMasterData();
  }

  onGridReady(params: any) {
    this.gridApi = params.api;

    window.addEventListener('resize', () => {
      this.gridApi.sizeColumnsToFit();
    });
  }

  onFirstDataRendered(params: any) {
    params.api.sizeColumnsToFit();
  }

  editProject(rowData: any) {
    this.commonDataObject.displayDialog = true;
    this.projectForm.patchValue({
      project_id: rowData?.project_id,
      project_name: rowData?.project_name,
      project_description: rowData?.project_description,
      project_coordinator: rowData?.project_coordinator,
      project_co_coordinator: rowData?.project_co_coordinator,
      is_active: rowData?.is_active || false
    });
  }

  addProject() {
    this.commonDataObject.displayDialog = true;
    this.projectForm.reset();
  }

  saveProject(arg?: any) {
    this.projectService.loading.set(true);
    const userCode = sessionStorage.getItem('user_code');
    const projectData = arg ? this.commonDataObject.selectedProject : this.projectForm.value;
    let payload = {
      "project_id": projectData.project_id ?? null,
      "project_name": projectData.project_name ?? "",
      "project_description": projectData.project_description ?? "",
      "project_coordinator": projectData.project_coordinator ?? "",
      "project_co_coordinator": projectData.project_co_coordinator ?? "",
      "is_active": projectData.is_active ? 1 : 0,
      "is_delete": arg ? 1 : 0,
      "user_code": userCode
    }
    this.clientService.postAPI(this.commonDataObject.APIObj.PROJECT_UPSERT, payload).subscribe((res: any) => {
      if (res && res.code == 'CSR_MS_OK_200') {
        this.commonDataObject.displayDialog = false;
        this.commonDataObject.deleteDialog = false;
        this.projectForm.reset();
        this.commonDataObject.apiMeassge = res.message;
        this.commonDataObject.issuccessAlert = true;
        this.projectService.getMasterData();
      }
      else {
        this.commonDataObject.apiMeassge = res.message;
        this.commonDataObject.iserrorAlert = true;
      }
      setTimeout(() => {
        this.projectService.loading.set(false);
        this.commonDataObject.issuccessAlert = false;
        this.commonDataObject.iserrorAlert = false;
      }, 1000);
    },
      (error) => {
        this.commonDataObject.iserrorAlert = true;
        this.commonDataObject.apiMeassge = error.error.message;
        setTimeout(() => {
          this.projectService.loading.set(false);
          this.commonDataObject.issuccessAlert = false;
          this.commonDataObject.iserrorAlert = false;
        }, 1000);
      });
  }

  cancel() {
    this.commonDataObject.displayDialog = false;
    this.projectForm.reset();
  }
}
